<script setup lang="ts">
  import { ref, watch } from 'vue'
  import YahooIcon from '../Icons/YahooIcon.vue'
  import type { SearchEngineIconState } from '../../utils/layout/getSearchEngineIconState'

  const props = withDefaults(
    defineProps<{
      icon: SearchEngineIconState
      size?: number
    }>(),
    { size: 16 }
  )

  const hasFaviconFailed = ref(false)
  watch(
    () => props.icon,
    () => {
      hasFaviconFailed.value = false
    }
  )
</script>

<template>
  <span
    v-if="icon.kind === 'pending'"
    data-testid="search-engine-icon-pending"
    aria-hidden="true"
    class="shrink-0"
    :style="{ width: `${size}px`, height: `${size}px` }"
  />
  <YahooIcon v-else-if="icon.kind === 'yahoo'" :size="size" />
  <img
    v-else-if="icon.kind === 'favicon' && !hasFaviconFailed"
    data-testid="search-engine-favicon"
    :src="icon.src"
    :width="size"
    :height="size"
    alt=""
    decoding="async"
    fetchpriority="low"
    referrerpolicy="no-referrer"
    class="shrink-0 rounded-sm object-contain"
    @error="hasFaviconFailed = true"
  />
</template>
